import {
  CustomModalLayout,
  CustomModalLayoutProps,
  ModalProps,
  Text,
  TableActionCellSecondaryAction,
} from '@wix/design-system';
import React from 'react';
import { observer } from 'mobx-react-lite';
import { CollectionModal } from '../CollectionModal';
import { ConditionalModalState } from '@wix/bex-core';

export interface CollectionActionCustomLayoutModalProps
  extends Partial<CustomModalLayoutProps> {
  state: ConditionalModalState<unknown>;
  onAfterClose?: ModalProps['onAfterClose'];
  actionProps?: Partial<TableActionCellSecondaryAction>;
}

function _CollectionActionCustomLayoutModal({
  state,
  content,
  onAfterClose,
  primaryButtonOnClick,
  secondaryButtonOnClick,
  onCloseButtonClick,
  ...rest
}: CollectionActionCustomLayoutModalProps) {
  const { modal } = state;

  return (
    <CollectionModal
      state={modal}
      onAfterClose={() => {
        state.afterClose();
        onAfterClose?.();
      }}
    >
      <CustomModalLayout
        dataHook="collection-action-modal"
        {...rest}
        onCloseButtonClick={(e) => {
          modal.close();
          onCloseButtonClick?.(e);
        }}
        primaryButtonOnClick={() => {
          modal.confirm();
          primaryButtonOnClick?.();
        }}
        secondaryButtonOnClick={() => {
          modal.decline();
          secondaryButtonOnClick?.();
        }}
        content={typeof content === 'string' ? <Text>{content}</Text> : content}
      />
    </CollectionModal>
  );
}

export const CollectionActionCustomLayoutModal = observer(
  _CollectionActionCustomLayoutModal,
);
